import * as React from "react";

interface CPHelpButtonProps {
  onClick: () => void;
  title?: string;
  "aria-label"?: string;
}

const CPHelpButton: React.FC<CPHelpButtonProps> = ({
  onClick,
  title,
  "aria-label": ariaLabel,
}) => (
  <button
    type="button"
    onClick={onClick}
    title={title}
    aria-label={ariaLabel ?? title}
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      background: "none",
      border: "1px solid #0066cc",
      borderRadius: "50%",
      width: 16,
      height: 16,
      padding: 0,
      fontSize: 10,
      fontWeight: "bold",
      color: "#0066cc",
      flexShrink: 0,
    }}
  >
    ?
  </button>
);

export default CPHelpButton;
